var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.4375,
    r: 11,
    fill: "#F84960"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 14.0859H10.3516L10.1719 6.0625H12.1719L11.9844 14.0859ZM10.1172 16.5391C10.1172 16.2422 10.2135 15.9974 10.4062 15.8047C10.599 15.6068 10.862 15.5078 11.1953 15.5078C11.5286 15.5078 11.7917 15.6068 11.9844 15.8047C12.1771 15.9974 12.2734 16.2422 12.2734 16.5391C12.2734 16.8255 12.1797 17.0651 11.9922 17.2578C11.8047 17.4505 11.5391 17.5469 11.1953 17.5469C10.8516 17.5469 10.5859 17.4505 10.3984 17.2578C10.2109 17.0651 10.1172 16.8255 10.1172 16.5391Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.62f3971e86d131f56344dd911c72f347.svg";
export { ForwardRef as ReactComponent };